import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Modal,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import * as Sentry from "@sentry/browser";
import { useAlert } from "react-alert";

import { useModalStyles } from "./styles";
import { makeRequest } from "../util";

const NO_OAUTH_TOKEN = "User does not have a GitHub OAuth token.";
const PERMISSION_NOT_GRANTED =
  "User did not give permission to the Freshpaint app to access the repo.";

export function isGitHubSetupError(msg) {
  return msg === NO_OAUTH_TOKEN || msg === PERMISSION_NOT_GRANTED;
}

export function GitHubSetupModal({ gitHubError, onClose }) {
  const classes = useModalStyles();
  const alert = useAlert();

  function onStartAppInstallation() {
    window.open("https://github.com/apps/freshpaint-app");
    onClose();
  }

  function onStartOAuth() {
    makeRequest("get_oauth_url", { integration_name: "github" })
      .then((response) => {
        window.open(response.data);
        onClose();
      })
      .catch((error) => {
        console.log(error);
        Sentry.captureException(error);
        alert.error("Something went wrong. Unable to setup GitHub.");
      });
  }

  return (
    <Modal onClose={onClose} open={gitHubError !== null}>
      <Card className={clsx(classes.root, classes.smallModal)}>
        <CardHeader
          title="Unable to find the provided GitHub Repository"
          classes={{ action: clsx(classes.closeIconAction) }}
          action={<CloseIcon onClick={onClose} />}
        />
        <Divider />
        <CardContent>
          <Typography variant="body1">
            Unable to find the provided GitHub repository.
            {gitHubError === NO_OAUTH_TOKEN
              ? " If the repository you provided is private, you'll need to OAuth into GitHub and install the Freshpaint GitHub app."
              : " If the repository you provided is private, you will need to install the Freshpaint GitHub app and give it permission to access the repository."}
          </Typography>
        </CardContent>
        <Divider />
        <CardActions className={classes.actions}>
          <Button
            className={clsx(classes.closeButton)}
            onClick={onClose}
            variant="contained"
          >
            Close
          </Button>
          <Button
            className={clsx(classes.acceptButton)}
            onClick={
              gitHubError === NO_OAUTH_TOKEN
                ? onStartOAuth
                : onStartAppInstallation
            }
            variant="contained"
          >
            {gitHubError === NO_OAUTH_TOKEN ? "GitHub OAuth" : "Install App"}
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
}

GitHubSetupModal.propTypes = {
  gitHubError: PropTypes.string,
  onClose: PropTypes.func,
};
